import React from 'react';
import {useFrontContext} from "v4/contexts/FrontContext";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectContactsTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectContactsTab/components/ProspectContactsTabListing/ProspectContactsTabListing";
import ProspectContactsTabMail
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectContactsTab/components/ProspectContactsTabMail/ProspectContactsTabMail";
import BaseContactTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseContactTab/BaseContactTab";

export default function ProspectContactsTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;
    const {t} = usePolTranslation();
    const {addLastVisit} = useFrontContext();

    const onGetData = (data) => {
        const hydraMember = data?.['hydra:member'];
        if (!hydraMember) return;

        const fullname = hydraMember.metadata?.fullname;
        addLastVisit({
            name: fullname ?? t('contact'),
            prospectId: prospectId,
            type: 'Contact',
            url: window.location.pathname,
        });
    }

    return (
        <BaseContactTab
            listingComponent={<ProspectContactsTabListing prospectId={prospectId}/>}
            mailComponent={<ProspectContactsTabMail prospectId={prospectId}/>}
            onGetData={onGetData}
        />
    )
}
